import { Sheet, SheetContent } from "@/components/ui/sheet";
import { GibletChatPanel } from "./GibletChatPanel";

interface GibletChatDialogEnhancedProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialCallType?: 'solution' | 'knowledge' | 'destruction' | 'start-call-flow' | null;
}

export const GibletChatDialogEnhanced = ({ 
  open, 
  onOpenChange,
  initialCallType
}: GibletChatDialogEnhancedProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-1/2 p-0 flex flex-col overflow-hidden">
        <GibletChatPanel initialCallType={initialCallType} />
      </SheetContent>
    </Sheet>
  );
};
